import React from 'react';
import { Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const formatPrice = (n) => `$${Number(n).toLocaleString('en-AU')}`;

const getContainerClass = ({ included, isSelected }) => {
  if (included) return 'border-green-500 bg-green-50 cursor-not-allowed opacity-75';
  if (isSelected) return 'border-[#C9A961] bg-[#C9A961]/10 cursor-pointer';
  return 'border-[#8B7355]/20 hover:border-[#8B7355]/40 cursor-pointer';
};

export const AddonsSelector = ({ addons, selectedAddons, isAddonIncluded, onToggle }) => (
  <Card className="border-2 border-[#8B7355]/20">
    <CardHeader>
      <CardTitle className="font-serif text-2xl text-[#8B7355]">Enhance Your Experience</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid md:grid-cols-2 gap-3">
        {addons.map((addon) => {
          const included = isAddonIncluded(addon.slug);
          const isSelected = selectedAddons.includes(addon.slug);
          const containerClass = getContainerClass({ included, isSelected });
          return (
            <div
              key={addon.slug}
              onClick={() => !included && onToggle(addon.slug)}
              className={`flex items-center justify-between p-4 border-2 rounded-lg transition-all ${containerClass}`}
              data-testid={`addon-${addon.slug}`}
            >
              <div>
                <p className={`font-serif ${included ? 'text-green-700' : 'text-[#8B7355]'}`}>
                  {addon.name}
                  {included && <span className="ml-2 text-xs font-normal">(Included)</span>}
                </p>
                <p className={`text-sm ${included ? 'text-green-600' : 'text-[#C9A961]'}`}>
                  {included ? '✓ Included in package' : formatPrice(addon.price)}
                </p>
                {addon.description && !included && (
                  <p className="text-xs text-[#8B7355]/60 mt-1">{addon.description}</p>
                )}
              </div>
              {!included && (
                <Plus className={`w-5 h-5 transition-transform ${
                  isSelected ? 'rotate-45 text-[#C9A961]' : 'text-[#8B7355]'
                }`} />
              )}
              {included && (
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                  <span className="text-white text-sm">✓</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {addons.length === 0 && (
        <p className="text-[#8B7355]/70 italic">No add-ons available right now.</p>
      )}
    </CardContent>
  </Card>
);
